import React from "react"
import { Layout, SEO, About, Mission, HomeTestimonial } from "../components";

const IndexPage = () => (
  <Layout>
    <div className="pgabt">
      <SEO title="About Us - Natural Silver Solutions | Professional Bio-Active colloidal silver supplement" description="Natural Silver Solutions. Professional Bio-Active colloidal silver supplement, delivers advantages no other manufacturer can match"/>
      <About/>
      <HomeTestimonial/>
      <Mission/>
    </div>
  </Layout>
)

export default IndexPage
